"use client"

import { CultureInfoMap } from "@/features/CultureInfoMap";
import { Wrapper } from "./_html";

export const CultureInfoMapBox = () => {
    return (
        <Wrapper>
            <CultureInfoMap/>
        </Wrapper>
    )
}